<template>
  <div class="sport" :style="{ color: settings.main.textColor }">
    <div class="sport__top">
      <div>
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.66667 0C6.15035 0 4.66808 0.449642 3.4073 1.29207C2.14652 2.13449 1.16387 3.33186 0.583594 4.73276C0.00332189 6.13366 -0.148504 7.67517 0.147316 9.16236C0.443136 10.6495 1.17332 12.0156 2.24552 13.0878C3.31772 14.16 4.68379 14.8902 6.17098 15.186C7.65816 15.4818 9.19968 15.33 10.6006 14.7497C12.0015 14.1695 13.1988 13.1868 14.0413 11.926C14.8837 10.6653 15.3333 9.18299 15.3333 7.66667C15.331 5.63405 14.5225 3.68535 13.0853 2.24807C11.648 0.81079 9.69929 0.00231147 7.66667 0ZM10.9377 11.7197L9.4155 10.0072L10.1498 7.63113L12.7357 6.33817L14.6664 7.6712C14.6652 9.14801 14.1937 10.5861 13.3204 11.777L10.9377 11.7197ZM13.323 3.55973L12.5807 5.6703L10.1409 6.8903L8 5.25463V2.41203L9.83117 1.01313C11.2339 1.47371 12.4558 2.3648 13.323 3.5597V3.55973ZM5.50217 1.01307L7.33334 2.41203V5.25463L5.19244 6.89L2.75267 5.67L2.01037 3.5597C2.87758 2.3648 4.09942 1.47371 5.50217 1.01313V1.01307ZM4.42797 11.719L2.0129 11.7771C1.13961 10.5861 0.668179 9.1481 0.666903 7.6713L2.59764 6.33827L5.18357 7.6312L5.9199 10.014L4.42797 11.719ZM5.507 14.322L4.87847 12.2167L6.52627 10.3333H8.81334L10.4632 12.1894L9.8265 14.322C8.42341 14.7816 6.9103 14.7816 5.5072 14.322H5.507Z"
            fill="#000000"
          />
        </svg>
        Спорт
      </div>
      <div>
        8
        <a-icon type="up" :style="{ color: settings.main.iconColor }" />
      </div>
    </div>
    <div class="sport__container" :style="{ background: bgColor }">
      <div class="sport__container-header">
        <div
          class="sport__champ-title"
          :style="{ color: settings.main.textColor }"
        >
          Название чемпионата
        </div>
        <a-icon type="up" :style="{ color: settings.main.iconColor }" />
      </div>
      <PhonePreviewMatch
        v-for="match in matches"
        :key="match.id"
        :match="match"
        :settings="settings"
      />
      <div class="sport__match live"></div>
    </div>
  </div>
</template>
<script>
import PhonePreviewMatch from '@/views/apps/custom-pages/components/phone/parts/PhonePreviewMatch.vue'

import { gradientBackground } from '@/services/utils/custom-pages'

export default {
  components: {
    PhonePreviewMatch,
  },
  props: {
    settings: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      matches: [
        {
          id: 1,
          status: 'live',
          time: '17 мин',
          teams: {
            home: 'Манчестер Юнайтед',
            away: 'Манчестер Сити',
          },
          score: {
            home: 1,
            away: 0,
          },
          halftimeScore: '(1:0)',
          note: 'первый тайм',
        },
        {
          id: 2,
          status: 'upcoming',
          datetime: 'Сегодня 16:30',
          venue: 'Лондон',
          teams: {
            home: 'Манчестер Юнайтед',
            away: 'Манчестер Сити',
          },
          odds: {
            p1: 2.68,
            x: 2.68,
            p2: 2.68,
          },
        },
        {
          id: 3,
          status: 'finished',
          datetime: '14.05.2021 22:00',
          teams: {
            home: 'Манчестер Юнайтед',
            away: 'Манчестер Сити',
          },
          score: {
            home: 1,
            away: 4,
          },
          halftimeScore: '(0:2)',
        },
      ],
    }
  },
  computed: {
    bgColor() {
      return this.settings?.main?.fill === 'gradient'
        ? gradientBackground(
            this.settings?.main?.mainColor,
            this.settings?.schema,
        )
        : this.settings?.main?.mainColor
    },
  },
}
</script>
<style scoped lang="scss">
.sport {
  padding: 0 6px;

  &__top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 6px;
    font-weight: 500;
    font-size: 10px;
    line-height: 12px;

    div {
      display: flex;
      align-items: center;
      gap: 6px;
    }

    svg {
      width: 12px;
      height: 12px;
    }
  }

  &__container {
    border-radius: 10px;
  }

  &__container-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 8px;
    line-height: 10px;
    font-weight: 500;
    padding: 12px 8px 8px;
    border-bottom: 1px solid #e4e9f0;

    svg {
      width: 12px;
      height: 12px;
    }
  }

  &__match {
    position: relative;
  }

  &__match.live::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;
    border-radius: 3px 3px 0px 0px;
  }
}
</style>
